import React from 'react';

import TextareaAutoresize from 'react-textarea-autosize';

import { useField } from 'formik';

import classNames from 'classnames';

import './index.scss';

const MutateTaskInput = ({ name, ...props }) => {
  const [field, fieldMeta] = useField(name);
  return (
    <>
      <TextareaAutoresize
        {...props}
        {...field}
        className={classNames(
          'mutate-task-input',
          { 'mutate-task-input-error': fieldMeta.error },
          // eslint-disable-next-line react/destructuring-assignment
          props.className,
        )}
      />
    </>
  );
};

export default MutateTaskInput;
